<template>
  <base-dialog
    :visible.sync="dialogVisible"
    hide-close
    :width="width"
    :height="height"
    disable-scroll
    :class="['edit-dialog', { 'no-bar': fullScreen }]"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
  >
    <template #header>
      <div class="header-wrap">
        <div class="title">
          {{ title }}
        </div>
        <el-radio-group
          v-model="widthLevel"
          class="radio-group"
          @change="widthLevelChange"
          :disabled="levelDisabled"
        >
          <el-tooltip class="item" effect="dark" content="固定两列布局" placement="bottom">
            <el-radio-button label="1">
              <svg-icon
                icon-class="detail_two-column"
                :style="widthLevel === '1' ? 'color:#1989fa' : 'color:#C0C4CC'"
                class="radio-icon"
              ></svg-icon>
            </el-radio-button>
          </el-tooltip>
          <el-tooltip class="item" effect="dark" content="自适应布局" placement="bottom">
            <el-radio-button label="2">
              <svg-icon
                :icon-class="widthLevel == '2' ? 'svgo_loose' : 'svgo_loose-gray'"
                class="radio-icon"
              ></svg-icon>
            </el-radio-button>
          </el-tooltip>
        </el-radio-group>
        <div class="switch-wrap">
          <el-switch v-model="onlyRequired" @change="initFormGroup"></el-switch>
          <span class="status">{{ !onlyRequired ? "全部" : "仅必填" }}</span>
        </div>
        <div class="operation-wrap">
          <base-button v-if="['create', 'copy'].includes(from)" class="save-btn" type="primary">
            <div @click="submit" class="left">保存</div>
            <dropdown-menu
              @click="clickSubmitDropdown"
              :menu-list="submitMenu"
              margin-top="6"
              trigger="hover"
              placement="bottom-end"
              width="180"
            >
              <div class="right"><i class="el-icon-arrow-down"></i></div>
            </dropdown-menu>
          </base-button>
          <base-button v-else type="primary" @click="submit">保存</base-button>
          <base-button @click="close">取消</base-button>
        </div>
      </div>
    </template>
    <div class="side-nav-wrap" v-ps :class="{ hidden: fullScreen }">
      <side-nav ref="sideMenu" :menu-list="sideMenu" @select="selectMenu"></side-nav>
    </div>
    <div v-loading="loading" v-ps ref="mainWrap" class="main-wrap">
      <template v-if="!structLoading">
        <form-group
          ref="formGroup"
          :only-required="onlyRequired"
          :groups="controlGroup"
          :width-level="widthLevel"
          :project-name="sheetData.projectName"
          :sheetDataServer="sheetDataServer"
          :availableSheets="availableSheets"
          :form-util="formUtil"
          @update="handleFieldUpdate"
          @refDataCreated="handleRefDataCreated"
          @widthLevelChange="setLevel"
        ></form-group>
        <sub-table
          v-for="control in relatedControls"
          ref="relatedControl"
          :key="dataId + '_' + control._cid"
          :parent-data="{ id: dataId, data: form }"
          :only-required="onlyRequired"
          :control="control"
          :available-sheets="availableSheets"
          :from="from"
          @change="handleRelatedControlChange(control, $event)"
          @full-screen="fullScreen = $event"
          class="related-control"
        ></sub-table>
        <ref-control
          ref="refControl"
          v-if="refControls.length > 0"
          :only-reuired="onlyRequired"
          :controls="refControls"
          :availableSheets="availableSheets"
          :form="form"
          :sheetId="sheetId"
          :sheetData="sheetDataServer"
          class="ref-control"
          @full-screen="fullScreen = $event"
          @update="handleRefControlChange"
        ></ref-control>
      </template>
    </div>
  </base-dialog>
</template>

<script>
import BaseButton from "@/components/UIComponents/Button"
import FormGroup from "@/components/Sheet/SheetForm/FormGroup"
import SideNav from "../SideNav"
import DropdownMenu from "@/components/UIComponents/DropdownMenu"
import { getAvailableSheets, getSheetDefForEdit } from "@/api/sheet/sheet"
import { getSheetDataForEdit, insertSheetData, updateSheetData } from "@/api/sheet/sheetData"
import { beforeSubmit } from "@/utils/sheet"
import { loadingService } from "@/utils/ui"
import { initUserData } from "@/utils/user"
import RefControl from "./RefControl"
import emitter from "@/mixins/emitter"
import { setFrontSetting, getFrontSetting } from "@/api/user"
import BaseDialog from "@/components/UIComponents/BaseDialog"
import SubTable from "@/components/Sheet/SubTable/SubTable"
import FormUtil from "@/components/Sheet/EditDialog/FormUtil"
import { initLocation } from "@/utils/location"

export default {
  name: "edit-dialog",
  components: {
    BaseDialog,
    BaseButton,
    FormGroup,
    SideNav,
    SubTable,
    DropdownMenu,
    RefControl
  },
  mixins: [emitter],
  props: {
    from: String, // ["create", "edit", "reference", "copy", "fillForm","batchFill","verify"]
    sheetId: String,
    dataId: String,
    refDataInfo: {
      type: Object,
      default: () => ({ _ccid: "", data: {} }) // 被关联的数据及cid
    },
    initData: Object,
    // 完成任务填表单传过来
    rawSheetData: Object, // 直接获取详情里的数据
    group: Object // 看板视图分组
  },
  data() {
    let editDialogType = {
      create: "新建",
      reference: "新建",
      copy: "新建",
      edit: "编辑"
    }
    let submitMenu = [{ title: "保存并新建下一条", command: "saveAndContinue" }]
    return {
      editDialogType,
      submitMenu,
      loading: true,
      structLoading: true,
      availableSheets: [],
      controlGroup: [],
      relatedControls: [],
      refControls: [],
      onlyRequired: false, // 仅必填
      form: {}, // 表单数据(非响应式)
      sheetDataServer: {},
      sheetInfo: {},
      sheetData: {},
      fullScreen: false, // 主从关联表格全屏
      status: {
        initial: true
      },
      calcSheetDataServerDebounced: null,
      widthLevel: "1",
      dialogSize: {},
      levelDisabled: false,
      dialogVisible: false
    }
  },
  provide() {
    return { status: this.status, rootFormVm: this }
  },
  computed: {
    appId() {
      return this.sheetInfo.appId
    },
    // dialog 标题
    title() {
      return this.editDialogType[this.from] + " " + (this.sheetInfo.name || "")
    },
    // 侧边菜单
    sideMenu() {
      let menuList = this.controlGroup
        .filter(group => !this._.isEmpty(group.controls.filter(control => control.display)))
        .map((group, index) => ({
          group: "formGroup",
          name: group.name,
          index
        }))
      for (let [index, control] of this.relatedControls.entries()) {
        menuList.push({ name: control.name, group: "relatedControl", index })
      }
      if (this.refControls.length > 0) {
        menuList.push({ name: "关联表", group: "refControl", index: 0 })
      }
      return menuList
    },
    width() {
      let result = ""
      switch (this.from) {
        case "create":
        case "reference":
        case "copy":
          result = (this.dialogSize.newWidth || 90) + "vw"
          break
        case "edit":
          result = (this.dialogSize.editWidth || 90) + "vw"
          break
        default:
          result = "calc(100% - 100px)"
          break
      }
      return result
    },
    height() {
      let result = ""
      switch (this.from) {
        case "create":
        case "reference":
        case "copy":
          result = (this.dialogSize.newHeight || 90) + "vh"
          break
        case "edit":
          result = (this.dialogSize.editHeight || 90) + "vh"
          break
        default:
          result = "calc(100% - 70px)"
          break
      }
      return result
    }
  },
  created() {
    this.calcSheetDataServerDebounced = this._.debounce(this.calcSheetDataServer, 500)
  },
  mounted() {
    this.$on("changeNavMenuVisible", this.changeNavMenuVisible)
  },
  methods: {
    async open() {
      await this.$nextTick() // 等待props传入
      this.onlyRequired = false
      this.status.initial = true
      this.loading = true
      this.structLoading = true
      // initUserData 是为了编辑修改用户字段的时候,能直接根据用户,获取到用户所在部门,然后填充给部门的默认值
      const sheetInfo = await getSheetDefForEdit(this.sheetId, this.dataId)
      this.sheetInfo = this._.cloneDeep(sheetInfo)
      this.dialogSize = this.sheetInfo.layout.extraSetting
      this.dialogVisible = true // 尽快弹出窗口,避免打开延迟过高
      const [availableSheets] = await Promise.all([
        getAvailableSheets({ appId: this.appId }),
        initUserData(this.appId),
        initLocation(),
        this.getFrontSetting()
      ])
      this.formUtil = new FormUtil({
        dataId: this.dataId,
        sheetInfo: sheetInfo,
        availableSheets: availableSheets,
        fillFields: this.fillControls, // 当fillDialog执行时，有这个参数
        formGetterFunc: () => this.form,
        updateFormFunc: ({ updateObj, initFromGroup = false, isFromSubTable = false }) => {
          this.form = Object.assign({}, this.form, updateObj)
          this.calcSheetDataServerDebounced()
          initFromGroup && this.$refs.formGroup?.init(this.form, Object.keys(updateObj))
          !isFromSubTable &&
            this.$refs.relatedControl?.forEach(component => component.onParentUpdateDebounced())
        }
      })
      this.availableSheets = Object.freeze(availableSheets)
      this.structLoading = false
      // 初始化表单
      this.divideIntoGroups(sheetInfo)
      this.formUtil.sheetDefUpdateCbk = sheetInfo => {
        // 用于字段规则改变时,重新初始化表单
        this.sheetInfo = sheetInfo
        this.divideIntoGroups(sheetInfo)
        this.$nextTick(() => this.commonInit())
      }
      await this.$nextTick()
      switch (this.from) {
        case "create":
        case "reference": // 新建并关联
          await this.initForCreate()
          break
        case "copy":
          await this.initForCopy()
          break
        case "edit":
        case "fillForm": // 按钮填写 和 任务完成填写
          await this.getSheetData().then(() => this.commonInit())
          break
        case "batchFill":
          this.form = {}
          this.commonInit()
          break
        case "verify": // 审批同意填写
          await this.getSheetData().then(() => this.commonInit())
          break
      }
      this.loading = false
      setTimeout(() => this.broadcast("rich", "force-update"))
    },
    commonInit() {
      this.initFormGroup()
      this.initRelatedControls()
      this.initRefControls()
      this.initSideMenu()
    },
    async initForCreate() {
      this.form = {}
      this.commonInit()
      let updateObject = {}
      if (this.from === "reference") {
        updateObject[this.refDataInfo._ccid] = [this.refDataInfo.data]
      }
      await this.formUtil.initForCreate(this.form, updateObject, this.group, this.from)
    },
    async initForCopy() {
      this.form = {}
      this.commonInit()
      await this.formUtil.initForCopy(this.form, this.initData)
    },
    getFrontSetting() {
      return getFrontSetting(this.sheetId).then(res => {
        if (res?.widthLevel) this.widthLevel = res.widthLevel.level
      })
    },
    close() {
      this.dialogVisible = false
    },
    initFormGroup() {
      if (!this.$refs.formGroup) return
      this.$refs.formGroup.init(this.form)
    },
    initRelatedControls() {
      this.$refs.relatedControl?.forEach(component => {
        component.init(this.form[component.control._cid])
      })
    },
    initRefControls() {
      if (!this.$refs.refControl) return
      let components = [].concat(this.$refs.refControl)
      components.forEach(component => component.init())
    },
    initSideMenu() {
      if (!this.$refs.sideMenu) return
      this.$refs.sideMenu.init()
    },
    async getSheetData() {
      let sheetData
      if (this._.isEmpty(this.rawSheetData)) {
        if (!this.dataId) return null
        sheetData = await getSheetDataForEdit({
          dataId: this.dataId,
          appId: this.sheetInfo.appId,
          sheetId: this.sheetId
        })
      } else {
        sheetData = this._.cloneDeep(this.rawSheetData)
      }
      this.sheetData = sheetData
      this.form = this._.cloneDeep(sheetData.data)
      this.calcSheetDataServerDebounced()
    },
    // 将各字段分组
    divideIntoGroups(sheetInfo) {
      let controlGroup = [],
        relatedControls = [],
        refControls = []
      for (let group of sheetInfo?.layout?.groupList || []) {
        if (group.cidList.length === 0) continue
        let controls = []
        for (let cid of group.cidList) {
          // 只对展示的字段进行分组
          let field = this.formUtil.controlMap[cid]
          if (!field) continue
          if (this.from === "reference") {
            if (field._cid == this.refDataInfo._ccid && this.refDataInfo.data?.id) {
              // 新建并关联的时候,要把相对应的关联表控件设为不可编辑
              field = Object.assign({}, field, { disabled: true })
            }
          }
          if (field._type === "ref" && !field.oneFlag && field.display) {
            if (field.related && !field.treeKey) {
              relatedControls.push(field)
            } else {
              refControls.push(field)
            }
          } else controls.push(field)
        }
        if (controls.length > 0) controlGroup.push({ name: group.name, controls })
      }
      this.controlGroup = controlGroup
      this.relatedControls = relatedControls
      this.refControls = refControls
    },
    // 处理 form 分组中的某个字段值发生变化
    handleFieldUpdate(cid, data) {
      this.status.initial = false
      this.formUtil.handleFieldUpdate({
        form: this.form,
        updateObj: { [cid]: data }
      })
    },
    calcSheetDataServer() {
      this.sheetDataServer = this.formUtil.getSheetDataServer(this.form, this.dataId)
    },
    // 新建并关联需移除 data 的 version 信息(若不移除，之后的更新会报错)
    handleRefDataCreated() {
      this.sheetData.version = null
    },
    // 主从关联表格发生变化
    handleRelatedControlChange(control, relatedTableData) {
      this.formUtil.handleFieldUpdate({
        form: this.form,
        updateObj: { [control._cid]: relatedTableData },
        isFromSubTable: true
      })
    },
    // 关联多条表格发生变化
    handleRefControlChange(refTableData) {
      this.handleFieldUpdate(refTableData._cid, refTableData.control)
    },
    // 提交前的数据校验
    async validate() {
      if (this.$refs.formGroup) {
        let result = await this.$refs.formGroup.validate()
        if (!result) return false
      }
      if (this.$refs.relatedControl) {
        let components = [].concat(this.$refs.relatedControl)
        for (let component of components) {
          let result = component.validate()
          if (!result) return false
        }
      }
      return true
    },
    // 点击保存下拉框里的菜单项
    clickSubmitDropdown(command) {
      switch (command) {
        case "saveAndContinue": {
          this.submit({ continueCreate: true })
          break
        }
      }
    },
    scrollToFormValidateErr() {
      setTimeout(() => {
        this.$el.querySelector(".el-form-item.is-error")?.scrollIntoView()
        this.$el.querySelector(".sub-table-item.is-error")?.scrollIntoView()
      })
    },
    // 提交
    async submit({ continueCreate } = {}) {
      const loading = loadingService({ text: "请求中" })
      if (this.loading) {
        this.$message.warning("请等待加载完成后操作")
        loading.close()
        return
      }
      if (!(await this.validate())) {
        this.scrollToFormValidateErr()
        loading.close()
        return
      }
      try {
        let res
        let successMsg = "保存成功！"
        let submitData = beforeSubmit({ form: this.form, fieldsMap: this.formUtil.controlMap })
        switch (this.from) {
          case "create":
          case "reference":
          case "copy": {
            successMsg = "新建成功！"
            res = await insertSheetData(this.sheetId, submitData)
            break
          }
          case "edit": {
            res = await updateSheetData(
              this.sheetId,
              this.dataId,
              this.sheetData.version,
              submitData
            )
            break
          }
        }
        this.$message.success(successMsg)
        this.$emit("after-submit", res || {}, this.from)
        if (continueCreate) {
          await this.initForCreate()
        } else {
          this.close()
        }
      } finally {
        loading.close()
      }
    },
    // 选中侧边菜单
    selectMenu(menu) {
      let offsetTop = null
      switch (menu.group) {
        case "formGroup":
          offsetTop = this.$refs["formGroup"].$el.querySelectorAll(".form-group-wrapper")?.[
            menu.index
          ]?.offsetTop
          break
        case "relatedControl":
          offsetTop = this.$refs["relatedControl"]?.[menu.index]?.$el.offsetTop
          break
        case "refControl":
          offsetTop = this.$refs["refControl"]?.$el.offsetTop
          break
      }
      if (offsetTop === null) return
      this.$refs.mainWrap.scrollTop = offsetTop
    },
    changeNavMenuVisible(state) {
      this.fullScreen = state
    },
    widthLevelChange(val) {
      setFrontSetting({ level: val }, this.sheetId, "widthLevel")
      this.widthLevel = val
    },
    setLevel(val) {
      if (val && this.widthLevel === "1") {
        this.widthLevelChange("2")
      }
      this.levelDisabled = val
    }
  }
}
</script>

<style lang="scss" scoped>
.edit-dialog {
  .header-wrap {
    flex: 1;
    display: flex;
    align-items: center;
    font-size: $font-size-title-first;
    height: 100%;
    .title {
      @include ellipsis;
      margin-right: auto;
      font-size: $font-size-title-first;
    }
    .switch-wrap {
      min-width: 120px;
      text-align: right;

      .status {
        text-align: left;
        display: inline-block;
        width: 60px;
        margin-left: 6px;
        font-size: 14px;
      }
    }
    .operation-wrap {
      display: flex;
      .save-btn {
        position: relative;
        padding: 0;
        overflow: hidden;
        background: none;
        ::v-deep {
          span {
            display: flex;
          }
        }
        .left {
          padding: 6px 10px 6px 15px;
        }
        .right {
          padding: 6px 10px 6px 7px;
        }
        .left,
        .right {
          background: $color-main;

          &:hover {
            background: rgba(25, 137, 250, 0.7) !important;
          }
        }
      }
    }
    .radio-group {
      ::v-deep {
        .el-radio-button__inner {
          padding: 4px 5px;
        }
        .el-radio-button__orig-radio:checked + .el-radio-button__inner {
          background-color: white;
        }
      }
      .radio-icon {
        height: 18px;
        width: 18px;
      }
    }
  }
  .main-wrap {
    display: flex;
    flex-wrap: wrap;
    align-content: flex-start;
    position: relative;
    z-index: 1;
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    padding: 15px 0 0 44px;
    .form-group,
    .related-control,
    .ref-control {
      width: calc(99% - 136px);
      margin-bottom: 32px;
      box-sizing: border-box;
      padding-right: 5px;
    }
    .ref-control {
      margin-top: 32px;
    }
  }
  .side-nav-wrap {
    z-index: 2;
    position: absolute;
    width: 136px;
    top: 0;
    bottom: 0;
    right: 0;
    &.hidden {
      visibility: hidden;
    }
  }
  ::v-deep .el-dialog {
    min-width: 600px;
    min-height: 300px;
    color: $color-font-first;
    .header {
      padding: 0 40px;
    }
    .el-dialog__body {
      padding: 0;
      margin: 0;
      position: relative;
      height: 100%;
    }
  }
}
</style>
